import {useLocation, useNavigate} from "react-router-dom";
import {useProcessingRequest} from "../../../store/selectors/tableManagementSelector";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {FullPayoutModuleSummary} from "../../../types/fullPayoutTypes";
import {fullPayoutApi} from "../../../api/fullPayoutApi";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import {Box, Typography} from "@mui/material";
import {CircularIndeterminate} from "../../../components/common/CircularIndeterminate";
import FullPayoutModuleCard from "../../../components/shopModules/FullPayoutModuleCard";

export default function FullPayoutOverviewPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const processingRequest = useProcessingRequest();

    const [modules, setModules] = useState<FullPayoutModuleSummary[]>([]);

    useEffect(() => {
        const load = async () => {
            const res = await fullPayoutApi.getModules();
            const result = res?.getResultOrNull() ?? [];
            setModules(result.sort((a, b) => a.orderDayInMonth - b.orderDayInMonth));
        };
        void load();
    }, []);

    const handleCardClick = (module: FullPayoutModuleSummary) => {
        navigate(`${location.pathname}/${module.id}`);
    };

    return (
        <>
            <PageTitle title={t("fullPayoutPage.title")} />

            <Box sx={{ p: 3 }}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                    {modules.map((module) => (
                        <FullPayoutModuleCard
                            key={module.id}
                            module={module}
                            onCardClick={handleCardClick}
                        />
                    ))}
                </Box>
            </Box>

            <CircularIndeterminate processingRequest={processingRequest} />
        </>
    );
}